import React from 'react'
import CoverImg from 'components/General/CoverImg'
import { Container} from 'react-bootstrap'
import Breadcrumb from 'components/breadcrumb/breadcrumb'
import MainTitle from 'components/General/MainTitle'
import culture from "../../assets/img/culture.jpg"
import Filters from 'components/Agenda Culturel/Filters'
import EventsGrid from 'components/Agenda Culturel/EventsGrid'

function AgendaCulturelAlger() {
 
  return (
    <>
    <CoverImg img={culture}/>
    <Breadcrumb/>
    <Container>
    <MainTitle>Agenda Culturel</MainTitle>
    {/* Evenements a venir */}
    <div className='my-5'>
      <h2 className='my-4 text-start'>Les évènements à venir</h2>
      <Filters type='future'/>
      <EventsGrid type='future' region="alger"/>
    </div>
    {/* Evenement passés */}
    <div  className='my-5'>
      <h2 className='my-4 text-start'>Les évènements passés</h2>
      <Filters/>
      <EventsGrid type='paste' region="alger"/>
    </div>
    </Container>
    </>
  )
}

export default AgendaCulturelAlger